// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"styles_closeIcon__yybSO","closeContainer":"styles_closeContainer__2Gae8"};